import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { actionPlan } from '../../../../service/actionPlans/actionPlanById'
import { actionPlansServices } from '../../../../../service/actionPlans'
import { httpFetch } from '../../../../../utils/crud'
import { mapActionPlanTypeEvidences } from '../utils'
import { SolverEvidence } from '../types'

interface UseSolveActionPlanResult {
  plan: actionPlan | null
  evidences: SolverEvidence[]
  isLoading: boolean
  error: boolean
  reload: () => void
}

export const useSolveActionPlan = (id: number | undefined): UseSolveActionPlanResult => {
  const { t } = useTranslation()
  const [plan, setPlan] = useState<actionPlan | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  const loadPlan = useCallback(async () => {
    if (!id) {
      setIsLoading(false)
      return
    }

    setIsLoading(true)
    setError(false)

    try {
      const response = await actionPlansServices(httpFetch).getById(id)
      setPlan(response)
    } catch (err) {
      console.error('Error loading action plan:', err)
      setError(true)
    } finally {
      setIsLoading(false)
    }
  }, [id])

  useEffect(() => {
    loadPlan()
  }, [loadPlan])

  const evidences = useMemo(
    () => mapActionPlanTypeEvidences(plan?.actionPlanTypeEvidences, t),
    [plan?.actionPlanTypeEvidences, t]
  )

  return {
    plan,
    evidences,
    isLoading,
    error,
    reload: loadPlan,
  }
}
